import { Loader2 } from 'lucide-react';
import useSubscriptionAccess from '../hooks/useSubscriptionAccess';
import LockedFeature from './LockedFeature';

/**
 * GatedRoute — wrap a route element to enforce a capability flag.
 *
 *   <GatedRoute capability="adaptive" requiredTier="advance" featureName="Adaptive Learning">
 *     <AdaptiveLearning />
 *   </GatedRoute>
 *
 * While access is loading, shows a spinner.
 * If the user lacks the capability, shows <LockedFeature> with an upgrade CTA.
 * Otherwise renders children.
 */
const GatedRoute = ({ capability, requiredTier = 'advance', featureName, children }) => {
  const { loading, has } = useSubscriptionAccess();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Loader2 className="h-10 w-10 animate-spin text-purple-600" />
      </div>
    );
  }

  if (!has(capability)) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 py-12 px-4">
        <div className="max-w-2xl mx-auto">
          <LockedFeature requiredTier={requiredTier} featureName={featureName} />
        </div>
      </div>
    );
  }

  return children;
};

export default GatedRoute;
